<template>
  <path
    d="M20.71 15.295a1 1 0 0 1-1.321 1.497l-.094-.083-7.293-7.297-7.293 7.297a1 1 0 0 1-1.32.083l-.094-.083a1 1 0 0 1-.083-1.32l.083-.094 8-8.004a1 1 0 0 1 1.32-.083l.094.083 8 8.004z"
    fill="#2E3233"
    fill-rule="nonzero"
  />
</template>
